import apiClient from '@services/apiClient';
import { useQuery } from '@tanstack/react-query';
import type { VOP_STATUS } from 'types/layout.ts';

import { useBankProfile } from '../contexts/BankProfileContext.tsx';

interface VopPayload {
	iban: string;
	name: string;
}

export interface VopResponse {
	uuid: string;
	match_status: VOP_STATUS;
	real_name: string;
}

export const useVop = (payload?: VopPayload) => {
	const { selectedProfile } = useBankProfile();
	const customerId = selectedProfile?.id;

	return useQuery({
		enabled: !!customerId && !!payload?.iban && !!payload?.name,
		queryKey: ['vop', customerId, payload?.iban, payload?.name],
		queryFn: async () => {
			const response = await apiClient.post<VopResponse>(
				`/profiles/${customerId}/accounts/verification-of-payee`,
				payload,
			);
			return response.data;
		},
		staleTime: Infinity,
		gcTime: 0,
	});
};
